import { z } from 'zod';

export const truckStatuses = [
  'created',
  'available',
  'in-use',
  'in-maintenance',
  'out-of-service',
] as const;

export type TruckStatus = (typeof truckStatuses)[number];

export const truckSizes = [
  'flat-bed-ford',
  'flat-bed-freightliner',
  'roll-off-truck',
  'grapple-roll-off-truck',
] as const; //TODO: These should come from the database

export type TruckSize = (typeof truckSizes)[number];

export const truckAddOns = [
  'roll-off-trailer',
  'tilt-goose-neck-trailer',
  'moffet',
  'roll-off-freightliner',
] as const; //TODO: These should come from the database

export type TruckAddOn = (typeof truckAddOns)[number];

export const truckZ = z.object({
  status: z.enum(truckStatuses),
  addOns: z.array(z.enum(truckAddOns)).optional(),
  size: z.enum(truckSizes),
  _id: z.string().optional(),
});

export type TruckZ = z.infer<typeof truckZ>;
